import avatarMaria from "~/assets/img/customer-trust/avatar-maria.svg";
import avatarJames from "~/assets/img/customer-trust/avatar-james.svg";
import avatarElena from "~/assets/img/customer-trust/avatar-elena.svg";
import avatarSophie from "~/assets/img/customer-trust/avatar-sophie.svg";
import avatarMarcus from "~/assets/img/customer-trust/avatar-marcus.svg";
import avatarNina from "~/assets/img/customer-trust/avatar-nina.svg";
import avatarOlivia from "~/assets/img/customer-trust/avatar-olivia.svg";

// Store testimonials shown on home and PDP. The last four entries once carried
// a "temporary presentation copy" note; the owner decided on 2026-09-16 that
// all eight are permanent production content, so the note was removed rather
// than the entries. Treat this list as owner-owned copy.
export const customerTrustContent = {
  title: "TRUSTED BY OVER 10K CUSTOMERS",
  subtitle: "Top-rated seller on Ebay, Poshmark, Grailed & more.",
  reviews: [
    {
      id: "maria-santos",
      name: "Maria Santos",
      avatar: avatarMaria,
      rating: 5,
      verified: true,
      content:
        "I bought these glasses about a month ago I think. They’re my first ever pair of glasses and I was iffy about if I would like them or not, but I LOVE them! They’re gorgeous and fit perfect.",
    },
    {
      id: "james-miller",
      name: "James Miller",
      avatar: avatarJames,
      rating: 5,
      verified: true,
      content:
        "I purchased these glasses maybe 3 weeks ago. Manufacture took short of 2 weeks with progressive lenses and all the extras. The frame quality is excellent and they fit perfectly right out of the box.",
    },
    {
      id: "elena-rossi",
      name: "Elena Rossi",
      avatar: avatarElena,
      rating: 5,
      verified: true,
      content:
        "Shipping was fast, packaging was beautiful, and the sunglasses feel premium. I have already recommended this store to two friends because everything from checkout to delivery felt smooth and reliable.",
    },
    {
      id: "daniel-kim",
      name: "Daniel Kim",
      avatar: avatarJames,
      rating: 5,
      verified: true,
      content:
        "Really impressed with the value. The pair looked exactly like the photos, customer support answered my questions quickly, and the whole experience felt much better than buying from a marketplace seller.",
    },
    {
      id: "sophie-carter",
      name: "Sophie Carter",
      avatar: avatarSophie,
      rating: 5,
      verified: true,
      content:
        "I was a little nervous ordering frames online, but they looked just like the pictures and fit me really well. They also came packed carefully, which I appreciated.",
    },
    {
      id: "marcus-reed",
      name: "Marcus Reed",
      avatar: avatarMarcus,
      rating: 5,
      verified: true,
      content:
        "Found the exact pair I had been looking for and the price was much better than what I saw locally. Shipping updates were clear and they arrived sooner than I expected.",
    },
    {
      id: "nina-patel",
      name: "Nina Patel",
      avatar: avatarNina,
      rating: 5,
      verified: true,
      content:
        "The size details were actually helpful, so I knew what I was getting before I ordered. I had them adjusted a tiny bit at my optician and now I wear them every day.",
    },
    {
      id: "olivia-brooks",
      name: "Olivia Brooks",
      avatar: avatarOlivia,
      rating: 5,
      verified: true,
      content:
        "This was my second order and it was just as easy as the first. The sunglasses arrived in perfect shape and the color is even nicer in person.",
    },
  ],
};
